<div *ngIf="userIsOffLine$ | async" class="offline-prompt">
  <i class="fas fa-wifi-slash"></i>
  You are currently Offline
  <span>
    Please make sure your internet connection is working, and this message will disappear.
  </span>
</div>
<router-outlet></router-outlet>
